import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setModelPanel } from "../redux/modelPanelSlice";
import ConversationSelect from "./scrollDiv/conversationMode";
import ModelSelect from "./scrollDiv/modelSelect";
// import SystemGroup from "./scrollDiv/SystemGroup";
import ImageUploader from "./ImageUploader";
import TemplateGroup from "./TemplateGroup";

function SettingPanel() {
  const modelPanel = useSelector((state) => state.modelPanel);
  const dispatch = useDispatch();
  return (
    <>
      <div
        className={`w-80  flex-none transition-all absolute z-[800] ${
          modelPanel === "hidden-right" && " -right-80 top-20 bottom-3"
        } ${modelPanel === "right" && " right-2 top-20 bottom-3"} ${
          modelPanel === "bottom" &&
          " -bottom-[15px] h-3/4 left-1/2 -translate-x-1/2 w-[95%] "
        } ${
          modelPanel === "hidden-bottom" &&
          " -bottom-[800px] h-3/4 left-1/2 -translate-x-1/2 w-[95%] "
        }
      `}
      >
        <div
          className={`flex-col overflow-y-scroll relative p-2 justify-center items-center h-full w-full bg-[hsla(var(--bg-100)/0.95)] text-white  rounded-xl shadow-lg border-[0.5px] border-[hsla(var(--border-300)/0.5)]`}
        >
          <CloseSymbol />
          <div className="flex justify-center items-center h-12 ">
            <p className="text-lg font-bold">Settings</p>
          </div>
          <div className="mb-3">
            <div className="mb-2 px-1 font-bold">Model</div>
            <ModelSelect />
          </div>
          <div className="mb-3">
            <div className="mb-2 px-1 font-bold">Context</div>
            <ConversationSelect />
          </div>
          <div className="mb-3">
            <div className="mb-2 px-1 font-bold">Images</div>
            <ImageUploader />
          </div>
          <div className="mb-3">
            <div className="mb-2 px-1 font-bold">Template</div>
            <TemplateGroup />
          </div>

          {/* <SystemGroup /> */}
        </div>
      </div>
      <div
        className={`fixed top-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 z-[700] transition-opacity duration-500 ${
          modelPanel === "bottom" ? "" : "opacity-0 pointer-events-none"
        } `}
        onClick={() => {
          dispatch(setModelPanel("hidden-bottom"));
        }}
      ></div>
    </>
  );
}

const CloseSymbol = () => {
  const modelPanel = useSelector((state) => state.modelPanel);
  const dispatch = useDispatch();
  return (
    <div className="absolute top-0 right-0 p-2">
      <button
        className="text-lg font-bold"
        onClick={() => {
          if (modelPanel === "right") {
            dispatch(setModelPanel("hidden-right"));
          } else {
            dispatch(setModelPanel("hidden-bottom"));
          }
        }}
      >
        X
      </button>
    </div>
  );
};

export default SettingPanel;
